import React from 'react'
import CreateAdd from './CreateAdd'
import { Route, Routes } from 'react-router-dom'
import MyAdds from './MyAdds'
import AddDetail from './AddDetail'

const Adds = () => {
    return (
        <div>
            <Routes>
                <Route path="/*" element={<MyAdds />} />
                <Route path="/createadd" element={<CreateAdd />} />
                <Route path="/addOverview/:id" element={<AddDetail />} />
            </Routes>
        </div>
    )
}

export default Adds